import { forwardRef, ForwardedRef } from 'react'

import classNames from 'classnames'

import { CommonRouteArrowIcon, CommonTrainIcon } from '@local/assets/icons'

import { openNewWindow } from '@web/hooks/useNavigation'
import { usePropsViewerMode } from '@web/libs/dev/MyplaceDevtools/usePropsViewer'
import sendClickLog from '@web/libs/nlog/click/sendClickLog'
import Clickable from '@web/ui/components/Clickable'
import FunctionButton from '@web/ui/components/FunctionButton'

import styles from '../UpComingSection.module.scss'

interface Props {
  item: {
    id: string
    label: string
    origin: string
    stopOver?: string
    destination: string
    bookingDateTime: string
    trainType: string
    seatInfo: string
    isToday?: boolean
    isBlackBadge?: boolean
    href?: string
  }
  isFlicking?: boolean
  ariaHidden?: boolean
  cardIdx?: number
  clickCodes?: {
    cardClick?: string
    bookingDetails?: string
  }
}
function TicketCardItem(props: Props, ref: ForwardedRef<HTMLLIElement>) {
  const { id, label, origin, stopOver, destination, bookingDateTime, trainType, seatInfo, isToday, isBlackBadge } =
    props.item
  const { isFlicking, ariaHidden, cardIdx } = props

  const { PropsViewer } = usePropsViewerMode({ props })

  if (PropsViewer) return <li ref={ref}>{PropsViewer}</li>

  // [D] 조건은 마크업 확인용으로 임시로 넣어놨습니다. 조건에 맞게 이어서 개발 부탁드립니다.
  // - isBookingRequestedOnly: 예약 신청중인 상태
  // - isToday: 오늘 진행 중인 일정
  // const isBookingRequestedOnly = label === '예약확인중'
  // const isToday = label === '오늘'

  const skipFocusProps = ariaHidden
    ? {
        'aria-hidden': true,
        tabIndex: -1,
      }
    : {}

  return (
    <li
      className={classNames(styles.list_item, { [styles.type_flicking]: isFlicking })}
      ref={ref}
      {...skipFocusProps}
      id={id}
    >
      <div className={classNames(styles.list_item_inner, { [styles.type_today]: isToday })}>
        <Clickable
          className={styles.list_item_link}
          {...skipFocusProps}
          href={props.item.href}
          nClickCode={props.clickCodes?.cardClick}
          nClickCid={id}
          nClickRank={cardIdx ? cardIdx + 1 : undefined}
        >
          <div className={styles.info_area}>
            <div className={styles.tit_area}>
              <div className={styles.tit_inner}>
                <span className={classNames(styles.label, { [styles.type_checking]: isBlackBadge })}>{label}</span>
                <span className={styles.name}>
                  {origin}
                  {stopOver && (
                    <>
                      <CommonRouteArrowIcon className={styles.icon} aria-hidden="true" />
                      {stopOver}
                      <span className="place_blind">경유</span>
                    </>
                  )}
                  <CommonRouteArrowIcon className={styles.icon} aria-hidden="true" />
                  {destination}
                  <span className="place_blind">도착</span>
                </span>
              </div>
            </div>
            {bookingDateTime && (
              <div className={styles.txt_area}>
                <time aria-hidden="true">
                  {/* [D] 23.12.20.수 */}
                  {bookingDateTime}
                </time>
                <span className="place_blind">
                  {/* [D] 23년 12월 20일 수요일 */}
                  {bookingDateTime}
                </span>
              </div>
            )}
            <div className={styles.etc_area}>
              <span className={styles.txt}>{trainType}</span>
              <em className={styles.count}>{seatInfo}</em>
            </div>
          </div>
          <div className={styles.thumb_area}>
            <div className={styles.icon_wrapper}>
              <CommonTrainIcon className={styles.icon} aria-hidden="true" />
            </div>
          </div>
        </Clickable>

        {/* 카드내부 하단 영역 */}
        <div className={styles.card_bottom_area}>
          <div className={styles.btn_area}>
            <span className={styles.btn_wrapper}>
              <FunctionButton
                type="RESERVATION_HISTORY"
                onClick={() => {
                  if (props.clickCodes?.bookingDetails)
                    sendClickLog({
                      area: props.clickCodes.bookingDetails,
                      contentId: id,
                    })

                  if (props.item.href) openNewWindow(props.item.href)
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </li>
  )
}
export default forwardRef(TicketCardItem)
